import { faImage } from "@fortawesome/pro-solid-svg-icons"
import { Grid, IconButton, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useAppLocalization } from "../../../localization/components/AppLocalizationProvider"
import { StandardChip } from "../../../../shared/components/badges/StandardChip"
import { ProductTableRow } from "./productsTypes"

type ProductGroupItemBoxProps = Readonly<{
    productGroup: ProductTableRow
}>

export function ProductGroupItemBox({ productGroup }: ProductGroupItemBoxProps) {
    return (
        <Typography variant="body1" fontWeight="bold">
            {productGroup.name}
        </Typography>
    )
}

type ProductNameProps = Readonly<{
    product: ProductTableRow
    onProductPhotoClick: (imageUrl: string) => void
}>

export function ProductName({ product, onProductPhotoClick }: ProductNameProps) {
    const { l10n } = useAppLocalization()
    const productPhotoUrl = product.productPhoto?.url

    return (
        <Grid container>
            <Grid container item columnGap={1.5} alignItems="center">
                <Grid item>{product.name}</Grid>
                {productPhotoUrl && (
                    <Grid item>
                        <IconButton onClick={() => onProductPhotoClick(productPhotoUrl)}>
                            <FontAwesomeIcon icon={faImage} fontSize="16px" color="#94A3B8" />
                        </IconButton>
                    </Grid>
                )}
                {product.marketingDetails?.isOffer && (
                    <Grid item>
                        <StandardChip
                            size="small"
                            label={l10n.getString("product-offer-chip")}
                            variant="yellow"
                            placement="table"
                        />
                    </Grid>
                )}
            </Grid>
        </Grid>
    )
}
